import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import { AppModule } from './app/modules/app.module';
import { environment } from './environments/environment';

import config from 'devextreme/core/config';
import { platformBrowser } from '@angular/platform-browser';

const licenseKey = environment.devExtremeKey
config({ licenseKey });

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
